module.exports = __webpack_public_path__ + "img/male.2570105c.png";